(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const widget = document.getElementById('product-video-widget');
    const modal = document.getElementById('product-video-modal');
    if (!widget) return;

    const widgetVideo = widget.querySelector('video');
    const widgetCloseButton = widget.querySelector('.product-video-widget__close');

    widgetCloseButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      widget.classList.add('is-hidden');
      widgetVideo?.pause();
    });

    // Drag to reposition, click (no movement) to open the modal.
    let isDragging = false;
    let moved = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;
    const DRAG_THRESHOLD = 6;

    widget.addEventListener('pointerdown', (event) => {
      if (event.target === widgetCloseButton || widgetCloseButton?.contains(event.target)) return;
      isDragging = true;
      moved = false;
      const rect = widget.getBoundingClientRect();
      startX = event.clientX;
      startY = event.clientY;
      startLeft = rect.left;
      startTop = rect.top;
      widget.setPointerCapture(event.pointerId);
    });

    widget.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;

      if (!moved && Math.hypot(dx, dy) > DRAG_THRESHOLD) {
        moved = true;
        widget.classList.add('is-dragging');
      }
      if (!moved) return;

      const maxLeft = window.innerWidth - widget.offsetWidth;
      const maxTop = window.innerHeight - widget.offsetHeight;
      const newLeft = Math.min(Math.max(startLeft + dx, 0), Math.max(maxLeft, 0));
      const newTop = Math.min(Math.max(startTop + dy, 0), Math.max(maxTop, 0));

      widget.style.left = `${newLeft}px`;
      widget.style.top = `${newTop}px`;
      widget.style.right = 'auto';
      widget.style.bottom = 'auto';
    });

    widget.addEventListener('pointerup', (event) => {
      if (!isDragging) return;
      isDragging = false;
      widget.classList.remove('is-dragging');
      widget.releasePointerCapture(event.pointerId);

      if (!moved) {
        openModal();
      }
    });

    if (!modal) return;

    const modalVideo = modal.querySelector('video');
    const muteButton = modal.querySelector('[data-action="mute"]');
    const volumeOnIcon = modal.querySelector('.icon-volume-on');
    const volumeOffIcon = modal.querySelector('.icon-volume-off');
    const closeButton = modal.querySelector('[data-action="close"]');
    const likeButton = modal.querySelector('[data-action="like"]');
    const shareButton = modal.querySelector('[data-action="share"]');
    const addToCartButton = modal.querySelector('.product-video-modal__add-btn');

    function openModal() {
      modal.hidden = false;
      widgetVideo?.pause();
      if (modalVideo) {
        modalVideo.currentTime = widgetVideo?.currentTime || 0;
        modalVideo.play().catch(() => {});
      }
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      modalVideo?.pause();
      widgetVideo?.play().catch(() => {});
      document.body.style.overflow = '';
    }

    closeButton?.addEventListener('click', closeModal);
    modal.querySelector('.product-video-modal__backdrop')?.addEventListener('click', closeModal);

    muteButton?.addEventListener('click', () => {
      if (!modalVideo) return;
      modalVideo.muted = !modalVideo.muted;
      if (volumeOnIcon) volumeOnIcon.style.display = modalVideo.muted ? 'none' : '';
      if (volumeOffIcon) volumeOffIcon.style.display = modalVideo.muted ? '' : 'none';
    });

    shareButton?.addEventListener('click', async () => {
      const shareData = { title: document.title, url: window.location.href };
      if (navigator.share) {
        navigator.share(shareData).catch(() => {});
      } else if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(shareData.url);
          const label = shareButton.querySelector('span');
          if (label) {
            const original = label.textContent;
            label.textContent = 'Copied!';
            setTimeout(() => {
              label.textContent = original;
            }, 1500);
          }
        } catch (error) {
          // Clipboard access denied; nothing further to do.
        }
      }
    });

    addToCartButton?.addEventListener('click', () => {
      const variantId = addToCartButton.dataset.variantId;
      if (!variantId || addToCartButton.disabled) return;

      const originalText = addToCartButton.textContent;
      addToCartButton.disabled = true;
      addToCartButton.textContent = '...';

      fetch((window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            addToCartButton.textContent = originalText;
            addToCartButton.disabled = false;
            return;
          }
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: data, sourceId: 'product-video-modal', data: {} },
            })
          );
          addToCartButton.textContent = 'Added';
          setTimeout(() => {
            addToCartButton.textContent = originalText;
            addToCartButton.disabled = false;
          }, 1500);
        })
        .catch(() => {
          addToCartButton.textContent = originalText;
          addToCartButton.disabled = false;
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
